<div class="main">
  <div class="container-fluid">
    <div id="profile-section">
      <div class="box-title">
        <h5 class="fw-bold">
          {{ "DCO.Title_Profile" | translate }}
        </h5>
        <p class="text-muted">{{"dco.profile_PageDescription" | translate}}</p>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12 px-4 pt-2">
              <h5 class="fw-semibold text-primary mb-4">
                {{ "DCO.Profile_Access" | translate }}
              </h5>
              <div class="d-flex">
                <div class="d-flex flex-column me-3 mb-3">
                  <label class="fw-semibold form-label mb-1">{{"DCO.profile_username" | translate}}</label>
                  <input type="text" class="form-control" value={{this.username}} readonly disabled>
                </div>
                <div class="d-flex flex-column me-3 mb-3">
                  <label class="fw-semibold form-label mb-1">{{"DCO.profile_password" | translate}}</label>
                  <input type="password" class="form-control" value="••••••••" readonly disabled>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12 px-4 py-2">
              <h5 class="fw-semibold text-primary mb-1">
                {{ "DCO.Profile_ContactData" | translate }}
              </h5>
              <p class="text-sm text-muted mb-4">{{ "DCO.Profile_ContactData_MaxContacts" | translate }} ({{this.totalContacts}}/5)</p>
               <div class="table-responsive border rounded-3 mx-0 px-0 overflow-y-hidden">
                <table class="table table-hover order-table" style="margin-top: -1px; margin-bottom: -1px;">
                  <thead>
                    <tr>
                      <th>{{ "DCO.Profile_ContactData_Name" | translate }}</th>
                      <th>{{ "DCO.Profile_ContactData_Email" | translate }}</th>
                      <th>{{ "DCO.Profile_ContactData_Phone" | translate }}</th>
                      <th>{{ "DCO.Profile_ContactData_Language" | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let c of contactGroups">
                      <td class="fw-semibold">{{ c.data?.TAG_Contacto }}</td>
                      <td>{{ c.data?.TAG_mails }}</td>
                      <td>{{ c.data?.TAG_ContactoTelf1 }}</td>
                      <td>{{ "CMP.ContactGroupsCard_Language" + c.language | translate }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12 px-4 py-2">
              <h5 class="fw-semibold text-primary mb-4">
                {{ "DCO.Profile_Commerces" | translate }}
              </h5>
              <div class="table-responsive border rounded-3 mx-0 px-0 overflow-y-hidden">
                <table class="table table-hover order-table" style="margin-top: -1px; margin-bottom: -1px;">
                  <thead>
                    <tr>
                      <th>{{ "DCO.Profile_CommerceNumber" | translate }}</th>
                      <th>{{ "DCO.Profile_CommerceName" | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let c of pagedCommerces">
                      <td>{{ c.commerceNumber }}</td>
                      <td>{{ c.commerceName }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-flex justify-content-center mt-4">
                <div class="d-flex align-items-center gap-3">
                  <button class="btn btn-light-primary btn-sm fw-bold" (click)="prevPage()" [disabled]="page === 1">
                    <i class="fa-solid fa-chevron-left fs-8"></i>
                    {{ "DCO.Profile_Commerces_Previous" | translate }}
                  </button>
                  <span class="text-sm text-muted fw-semibold">
                    {{ "DCO.Profile_Page" | translate }} {{ page }} {{ "DCO.Profile_PageOf" | translate }} {{
                    totalPages }}
                  </span>
                  <button class="btn btn-light-primary btn-sm fw-bold" (click)="nextPage()"
                    [disabled]="page * pageSize >= totalRows">
                    {{ "DCO.Profile_Commerces_Next" | translate }}
                    <i class="fa-solid fa-chevron-right fs-8"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>